export enum CacStateEnum {
  UNBLOCK= 'UNBLOCK',
  BLOCK= 'BLOCK',
  BLOCK_INCOMING= 'BLOCK_INCOMING',
  BLOCK_OUTGOING= 'BLOCK_OUTGOING'
}
